import React from 'react';
import './About.css';

function About() {
  return (
    <section className="about">
      <h2>About</h2>
      <ul className="about-list">
        <li>
          <span className="bullet">•</span>
          CS Major at UTD
        </li>
        <li>
          <span className="bullet">•</span>
          Entrepreneurship Minor
        </li>
        <li>
          <span className="bullet">•</span>
          Seeking Software Engineering Internship
        </li>
        <li>
          <span className="bullet">•</span>
          Brother of Alpha Kappa Psi Fraternity
        </li>
        <li>
          <span className="bullet">•</span>
            Logical
        </li>
        <li>
          <span className="bullet">•</span>
          Creative
        </li>
        <li>
          <span className="bullet">•</span>
          Collaborative
        </li>
        <li>
          <span className="bullet">•</span>
          Curious
        </li>
      </ul>
    </section>
  );
}

export default About; 
